module.exports = __webpack_public_path__ + "static/media/Arcon-01.8a355803.svg";